export const SET_BUDGETS = 'SET_BUDGETS'
export const ADD_BUDGET = 'ADD_BUDGET'
export const UPDATE_BUDGET = 'UPDATE_BUDGET'
export const DELETE_BUDGET = 'DELETE_BUDGET'
export const SET_ACTIVE_BUDGET = 'SET_ACTIVE_BUDGET'
